import LineWaves from './LineWaves';

// colors prop = [color1, color2, color3]
export default function PrismaticBurst({ colors = ['#325998','#f4f4f4','#101D32'] }) {
  const [c1, c2, c3] = colors;
  return (
    <div style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
      <LineWaves
        speed={0.3}
        innerLineCount={32}
        outerLineCount={36}
        warpIntensity={1}
        rotation={-45}
        edgeFadeWidth={0}
        colorCycleSpeed={1}
        brightness={0.22}
        color1={c1}
        color2={c2}
        color3={c3}
        enableMouseInteraction
        mouseInfluence={2}
      />
    </div>
  );
}
